import { instance } from '../../util/http'
import apis from '../../config/apis'

// 未支付订单数量
const getUnPaidOrder = () => {
return instance.get(apis.UserCenterPage.GetUnPaidOrder)
}

const refreshUnion = (RefreshUnionId)=>{
    return instance.put(apis.UserCenterPage.PutRefreshUnionId,RefreshUnionId)
}

const qrCode = ()=>{
    return instance.get(apis.UserCenterPage.QrCode)
}
const getNum = ()=>{
    return instance.get(apis.UserCenterPage.Quantity)
}
const list = (id,page,limit)=>{
    return instance.get(apis.UserCenterPage.List + "?LevelId=" + id + "&Page=" + page + "&Limit=" + limit)
}
const detail = (id)=>{
    return instance.get(apis.UserCenterPage.Detail + "?employeeid=" + id)
}
// lhy 绑定用户分享二维码
const userShareCodeUrl    = () => {
    return instance.get(apis.UserCenterPage.userShareCodeUrl)
}

export default {
    getUnPaidOrder,
    refreshUnion,
    qrCode,
    getNum,
    list,
    detail,
    userShareCodeUrl
}